import React, {Component} from 'react';
import IntroPanel from './layout/IntroPanel';
import RegionPanel from './layout/RegionPanel';
import LocationPanel from './layout/LocationPanel';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

class DataSection extends Component{
    render(){
        let regionPanel = !this.props.currentRegion ?  <IntroPanel {...this.props} /> : <RegionPanel  key={'region'} {...this.props} />
        let locationPanel = !this.props.currentLocation ? '' :  <LocationPanel key={'location'} {...this.props } />
        return(
        <div className="large-6 small-12 columns component-data-wrapper">             
            
            <ReactCSSTransitionGroup transitionName="inview-region" transitionEnterTimeout={300} transitionLeaveTimeout={300}>
                {regionPanel}
            </ReactCSSTransitionGroup>
            <ReactCSSTransitionGroup transitionName="inview" transitionEnterTimeout={300} transitionLeaveTimeout={300}>
                {locationPanel}
            </ReactCSSTransitionGroup>
        </div>   
        )
    }
}

export default DataSection;


// WEBPACK FOOTER //
// ./src/js/components/DataSection.js